import src from "IMAGE";
export default { src, width: 161, height: 49, blurWidth: 0, blurHeight: 0};
